<template>
  <!--单项选择题-->
  <div @click="setEditIndex(index)">
		<p v-if="isBankViewTest" class="my-bank-tag">{{$t('main.Radio')}}</p>
    <el-row :gutter="10" class="question-box">
      <el-col v-if="!isBankViewTest" :xs="1" :sm="1" :md="1" :lg="1" :xl="1" class="askxh">
        {{ question.quesIndex + 1 }}
      </el-col>
      <el-col
        :xs="15"
        :sm="15"
        :md="15"
        :lg="15"
        :xl="15"
        class="item_container_title"
        @click="setActiveInput(question.qid)"
      >
        <span style="line-height: 30px" v-if="isBankViewTest && question.questionsName">{{question.questionsName}}</span>
				
        <TitleEditor 
          :isTest="true"
					v-if="!isBankViewTest" 
					class="outline-none" 
					:qid="question.qid" 
					:class="question.qid"  
					:value="question.questionsName" 
          :actionTitleEditorShow="activeInputId === question.qid"
					@childValueChange="val=>{ question.questionsName = val }" 
				></TitleEditor>
        <div v-if="question.optionRelationTips != ''" style="color: #ccc">
          {{ question.optionRelationTips }}
        </div>
      </el-col>
			<el-col class="setBtn-box" :xs="7" :sm="7" :md="7" :lg="7" :xl="7" v-if="!$route.query.index">
				<OperateWrap
					style="display: flex;
						width: 100%;
						justify-content: end;
					"
					:bankId="$route.query.bankId"	
					:question="question"
				></OperateWrap>
			</el-col>
    </el-row>

    <div>
      <div v-if="question.groupingOptionList && question.groupingOptionList.length > 0">
        <!-- 分组 -->
        <el-row
          style="margin-top: 12px"
          v-for="childItem in question.groupingOptionList"
          :key="childItem.gid"
        >
          <p style="font-size: 14px; margin-left: 50px">
            {{ childItem.groupName }}
          </p>
          <el-row class="elcol-option group-option">
            <template v-if="childItem.optionList">
              <draggable
                v-bind="draggableOptions"
                v-model="childItem.optionList"
              >
                <transition-group
                  tag="div"
                  type="transition"
                  name="flip-list"
                >
                  <el-col
                    v-for="(option) in childItem.optionList"
                    :key="option.oid"
                    :style="{
                        width: `${100 / question.showcolnum}%`
                    }"
                  >
                    
                    <div class="option" @click="setEditOptionIndex(option.oid)">
                      <div class="option-icon"></div>
                      <div class="div-input">
                        
                        <div style="width: 100%;" @click="setActiveInput(option.oid)">
                          <span v-if="isBankViewTest">{{option.labelName}}</span>
                          <TitleEditor 
                            v-if="!isBankViewTest" 
                            class="outline-none" 
                            :qid="option.oid" 
                            :class="option.oid"  
                            :value="option.labelName" 
                            :actionTitleEditorShow="activeInputId === option.oid"
                            @childValueChange="(val) => labelNameChange(val, option)" 
                          ></TitleEditor>
                        </div>
                        <div 
                          v-if="option.haveInput"
                          class="other-input">
                          <el-input
                            disabled
                            size="mini"
                            v-model="value"
                            >
                          </el-input>
                        </div>
                      </div>
                      
                      <div
                        class="control"
                        v-if="editOptionIndex == option.oid"
                      >
                      <i class="option-handle el-icon-rank el-icon-common-option" ></i>
                        <i
                          class="el-icon-s-tools el-icon-common-option"
                          @click.stop="
                            wjsetquestionoption(option)
                          "
                        ></i>
                        <i
                          class="el-icon-remove el-icon-common-option"
                          @click.stop="wjdelquestionoption(option.oid)"
                        ></i>
                      </div>
                    </div>
                  </el-col>
                </transition-group>
              </draggable>
            </template>
          </el-row>
        </el-row>
        <span class="clear"></span>
      </div>
      <div>
        <!-- 默认 -->
        <el-row class="elcol-option">
          <div v-if="associatedList.length > 0" class="option associated">
            <div class="option-item" v-for="el in associatedList" :key="el.id">
              <div class="el-icon-d-arrow-right"></div>
              {{$t('main.AssociatedFrom')}}Q{{el.quesIndex + 1}}{{$t('main.de')}}{{el.optionList.length}}{{$t('main.Options')}}:
              <span v-for="(optionItem, opIndex) in el.optionList" :key="optionItem.oid">{{opIndex == 0 ? '' : '、'}}{{$functions.htmlFormat(optionItem.labelName)}}</span>
            </div>
          </div>
          <draggable
            v-bind="draggableOptions"
            v-model="question.optionList"
          >
            <transition-group
              tag="div"
              type="transition"
              :name="'flip-list'"
            >
              <el-col
                v-for="(option) in question.optionList"
                :key="option.oid"
                :style="{
                    width: `${100 / question.showcolnum}%`
                }"
              >
                <div class="option" @click="setEditOptionIndex(option.oid)">
                  <div class="option-icon"></div>
                  <div class="div-input">
                    
                    <div style="width: 100%;" @click="setActiveInput(option.oid)">
                      <span v-if="isBankViewTest">{{option.labelName}}</span>
                      
                      <TitleEditor 
                        v-if="!isBankViewTest" 
                        class="outline-none" 
                        :qid="option.oid" 
                        :class="option.oid"  
                        :value="option.labelName" 
                        :actionTitleEditorShow="activeInputId === option.oid"
                        @childValueChange="(val) => labelNameChange(val, option)" 
                      ></TitleEditor>
                    </div>
                    <div 
                      v-if="option.haveInput"
                      class="other-input">
                      <el-input
                        disabled
                        size="mini"
                        v-model="value"
                        >
                      </el-input>
                    </div>
                  </div>
                  <div
                    class="control"
                    v-if="editOptionIndex == option.oid"
                  >
                    <i class="option-handle el-icon-rank el-icon-common-option" ></i>
                    <i
                      class="el-icon-s-tools el-icon-common-option"
                      @click.stop="
                        wjsetquestionoption(option)
                      "
                    ></i>
                    <i
                      v-if="question.optionList.length != 1 || question.relation.length > 0"
                      class="el-icon-remove el-icon-common-option"
                      @click.stop="
                        wjdelquestionoption(option.oid)
                      "
                    ></i>
                  </div>
                </div>
              </el-col>
            </transition-group>
          </draggable>
        </el-row>

        <span class="clear"></span>
      </div>
    </div>

    <el-row
      :gutter="10"
      style="margin-top: 12px !important"
      v-if="question.isedit && !isBankViewTest"
    >
      <el-col
        :xs="16"
        :sm="16"
        :md="16"
        :lg="16"
        :xl="16"
        class="el_item_option item_container_title"
        style="margin-left: 50px"
		v-if="!$route.query.index"
      >
        <i
          class="el-icon-plus el-icon-common"
          @click="wjaddquestionoption()"
          >{{$t('main.AddOptions')}}</i
        >
        <i
          class="el-icon-s-fold el-icon-common"
          @click="$refs.batchAdd.batchAddshow = true"
          >{{$t('main.BatchAdd')}}</i
        >
        <i
          class="el-icon-menu el-icon-common"
          @click="addOther"
          >{{$t('main.AddOther')}}</i
        >
      </el-col>
    </el-row>
		<BatchAddOption 
			ref="batchAdd"
			:title="$t('main.option')" 
			:functionName="'batchAdd'"
      :question="question"
			@batchAdd="batchAdd"
		/>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex';
import OperateWrap from "./collectToBank/operateaWrap.vue"
import TitleEditor from "@/components/titleEditor/titleEditor.vue"
import BatchAddOption from "@/components/myComponents/batchAddOption/batchAddOption.vue"
export default {
	components: {
    TitleEditor,
		BatchAddOption,
		OperateWrap
	},
  data() {
    return {
      editOptionIndex: "0",
      set: "set",
      value: '',
      associatedList: [],
			draggableOptions: {
				handle: '.option-handle'
			},
    };
  },
  props: {
    question: {},
    editIndex: { type: Number, default: 0 },
    isExistPage: { type: Boolean, default: false },
    index: { type: Number, default: 0 },
    questionList:{
      type: Array,
      default:() =>[]
    },
		// 管理题库时查看试题 只可以删除
		isBankViewTest: {
			type: Boolean,
			default: false
		},
  },
  computed: {
    ...mapState(['activeInputId']),
    span() {
      var _span = { 1: 24, 2: 12, 3: 8 };
      return _span[question.choiceLayout];
    },
  },
  watch: {
    'question.relation': {
      handler(vnew, vold) {
        // console.log(vnew)
        // console.log(this.questionList)
        // console.log(`question.relation监听到了：${vnew}`)
        
        if (vnew.length > 0 && vnew[0].id) {
          this.associatedList = []
          if (vnew) {
            vnew.forEach(el => {
              this.questionList.forEach((info) => {
                if (el.id == info.qid) {
                  this.associatedList.push(info)
                }
              })
            })
          }
        }
        // console.log(this.associatedList)
      },
      deep: true,
      immediate: true
    },
    'question.isedit':{
			handler(newV, oldV){
				this.editOptionIndex = ''
			},
			deep: true
		},
  },
	mounted(){
    // optionList只监听一次
		const unwatch = this.$watch('question.optionList', {
      handler(newValue) {
        this.question.optionList = this.question.optionList.map((info) =>{
          this.$set(info, 'isDefault', false)
          return info
        })
        unwatch()
      },
      deep: true
    });
	},
  methods: {
    ...mapActions(['setActiveInput']),
    labelNameChange(val, option) {
      option.labelName = val
    },
    addOther(){
      this.$emit("wjaddquestionoption", this.question.qid, [this.$t('main.other')], this.question.questionsTypeId, true)
    },
    batchAdd(optionArr) {
      this.$emit("wjaddquestionoption", this.question.qid, optionArr, this.question.questionsTypeId);
    },
    wjaddquestionoption() {
      this.$emit("wjaddquestionoption", this.question.qid, [this.$t('main.NewOptions')], this.question.questionsTypeId);
    },
    // 选项设置
    wjsetquestionoption(option) {
      this.$emit("wjsetquestionoption", this.question, option)
    },
    setEditIndex(index) {
      this.$emit("setEditIndex", index);
    },
    setEditOptionIndex(childIndex) {
      this.editOptionIndex = childIndex;
    },
    wjdelquestionoption(oid) {
      this.$emit("wjdelquestionoption", { qid: this.question.qid, oid });
    },
  },
};
</script>

<style scoped lang="scss">
/deep/.el-input {
  width: 61% !important;
}
.inputStyle {
  border: 1px solid #cccccc !important;
  width: 50px;
  height: 25px;
}
/*输入框input*/
/deep/.two_lines .el-input__inner {
  width: 80px !important;
}
.item .el-badge__content.is-fixed {
  top: 10px;
}
.item.drag-handle {
  cursor: move;
}
.el_item_option {
  line-height: 40px;
  // height: 44px;
}

.el-icon-common {
  margin-right: 23px;
  font-size: 16px !important;
  line-height: 40px !important;
  color: cornflowerblue;
  cursor: pointer;
}

.el-icon-common-option {
  margin-left: 10px;
  font-size: 16px;
  line-height: 30px !important;
  color: cornflowerblue;
  cursor: pointer;
}


.title-input {
  display: inline-block;
  width: 100%;
  line-height: 40px;
  color: #606266;
  font: 400 13.3333px Arial;
  padding: 10px 15px 0 15px;
}

.elcol-option {
  padding: 0 70px;
}
.group-option{
  padding-left: 85px;
}
.option {
  display: flex;
  min-height: 30px;
  line-height: 34px;
  margin-top: 10px;
}
/* 选项icon */
.option .option-icon {
  vertical-align: middle;
}
.option .option-icon::after {
  content: "";
  display: inline-block;
  border: 1px solid #dcdfe6;
  border-radius: 100%;
  width: 14px;
  height: 14px;
  background-color: #fff;
  cursor: pointer;
  box-sizing: border-box;
}
/* 选项输入 */
.option .div-input {
  display: flex;
  flex: 1;
  margin: 0 25px;
  width: 0;
  font-size: 14px;
  font-family: Arial;
  color: #606266;
}
/* 选项操作 */
.option .control {
  width: 96px;
  margin-right: 10px;
}
.option .fill-empty::after {
  content: "XXXXXXXXX";
  display: inline;
  margin-left: 20px;
  width: 100px;
  height: 18px;
  border: 1px solid #adaeaf;
  border-radius: 2px;
  background-color: #fff;
  color: rgba(0, 0, 0, 0);
  overflow-wrap: normal;
  word-break: keep-all;
}
.clear {
  display: block;
  height: 1px;
  width: 1px;
  clear: both;
}

/deep/.el-textarea .el-textarea__inner {
    border: 1px solid #DCDFE6 !important;
    background-color: #FFF;
}
.other-input{
    width: 80px;
    margin-left: 10px;
    
}
.other-input /deep/.el-input--mini .el-input__inner{
  height: 22px;
  line-height: 22px;
}
.outline-none{
  /* display: inline-block; */
  outline: none;
  // max-width: 73%;
}
.associated{
  display: block;
  color: #aaa;
}
</style>
